import { AxiosResponse } from 'axios';
import Api from './api';

const UploadImageApi = (
  data: any,
  mediaType: 'image' | 'video',
): Promise<AxiosResponse> => {
  const path = `/admin/${mediaType}/upload`;
  return Api.getInstance().request.post(
    path,
    data,
    undefined, // No additional path
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress: (e: any) => {},
    },
  );
};

export default UploadImageApi;
